var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 132C72 98.8629 98.8629 72 132 72C165.137 72 192 98.8629 192 132C192 165.137 165.137 192 132 192C98.8629 192 72 165.137 72 132Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.29 159.5Q150.02 159.5 157.94 145.6L166.23 149.3Q161.61 157.93 153.21 162.44Q144.87 166.95 133.81 166.95Q122.44 166.95 114.26 162.73Q106.07 158.5 101.66 150.72Q97.3 142.9 97.3 132.27Q97.3 121.59 101.66 113.96Q106.02 106.32 114.2 102.24Q122.39 98.16 133.76 98.16Q145.72 98.16 153.74 102.33Q161.77 106.51 165.54 114.72L155.92 117.56Q153.32 111.73 147.53 108.64Q141.79 105.56 133.87 105.56Q121.43 105.56 114.52 112.72Q107.61 119.84 107.61 132.27Q107.61 140.43 110.86 146.6Q114.15 152.72 120.1 156.13Q126.11 159.5 134.29 159.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8361f61ad21c805c892cb0f1d28febe2.svg";
export { ForwardRef as ReactComponent };